import { render } from "./ImportRevertPopup.vue?vue&type=template&id=63b33a7a&scoped=true"
import script from "./ImportRevertPopup.vue?vue&type=script&lang=js"
export * from "./ImportRevertPopup.vue?vue&type=script&lang=js"

import "./ImportRevertPopup.vue?vue&type=style&index=0&id=63b33a7a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b33a7a"]])

export default __exports__